import { jsx as _jsx } from "react/jsx-runtime";
import { ApplicationContainer } from '@cmd/ui-components';
import { getLocale } from '@cmd/ui-utilities';
import { InterstateThemeProvider } from '@interstate/components/InterstateThemeProvider';
import { interstateThemeRegistry } from '@interstate/components/InterstateTheming/themes/interstateThemeRegistry';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { Provider as StoreProvider } from 'react-redux';
import packageJson from '../package.json';
import LandingPage from './LandingPage';
import store from './store';
import './index.css';
import '@cmd/ui-components/dist/main.css';
const { cmdLabels, } = window;
const { localeMessages, localeName, } = getLocale(cmdLabels, 'en_US');
const root = createRoot(document.getElementById('root'));
root.render(_jsx(StoreProvider, { store: store, children: _jsx(InterstateThemeProvider, { applicationName: "Command Center", scopeName: "Command Center Landing Page", themeName: "Interstate", themeRegistries: [interstateThemeRegistry], children: _jsx(IntlProvider, { defaultLocale: "en", locale: localeName, messages: localeMessages, textComponent: "span", children: _jsx(ApplicationContainer, { packageJson: { info: packageJson }, children: _jsx(LandingPage, {}) }) }) }) }));
